import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TUser } from '../../types/userData';
import { SliceActions } from '../types';

const initialState: TUser = { canPublishOffer: false, isAuthenticated: false, publicProfile: false, userId: 0 };

const userSlice = createSlice({
  name: 'session',
  reducers: {
    setUserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload;
    },
  },
  initialState,
});

export const userReducer = userSlice.reducer;
export const { setUserId } = userSlice.actions;
export type TUserActions = SliceActions<typeof userSlice.actions>;
